import React from 'react';
import { ShepherdLensLogo } from '../Logo/ShepherdLensLogo';

// AppHead is the top of the page that contains the product logo.
export const AppHead: React.FC = () => {
  return (
    <div className="absolute top-0 flex w-full items-center justify-center py-8">
      <ShepherdLensLogo size="lg" stacked />
    </div>
  );
};
